import { privateTelemetry } from './src/lib/telemetry-privacy';
import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  beforeSendTransaction: event => privateTelemetry(event),
  beforeBreadcrumb: breadcrumb => privateTelemetry(breadcrumb),

  // Adjust this value in production, or use tracesSampler for finer control
  tracesSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      beforeAddRecordingEvent: event => {
        let truncated = false;
        const cleaned = privateTelemetry(event, () => { truncated = true; });
        // A partial DOM snapshot is not a valid replay frame.
        return truncated ? null : cleaned;
      },
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Filter out sensitive data
  beforeSend(event) {
    // Remove any potential PII from breadcrumbs
    if (event.breadcrumbs) {
      event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
        if (breadcrumb.data) {
          // Remove sensitive fields
          const sensitiveFields = ['password', 'token', 'secret', 'authorization', 'api_key'];
          sensitiveFields.forEach(field => {
            if (breadcrumb.data && field in breadcrumb.data) {
              breadcrumb.data[field] = '[Filtered]';
            }
          });
        }
        return breadcrumb;
      });
    }

    // Filter query strings that might contain tokens
    if (event.request?.url) {
      try {
        const url = new URL(event.request.url);
        if (url.searchParams.has('token')) {
          url.searchParams.set('token', '[Filtered]');
          event.request.url = url.toString();
        }
      } catch {
        // Invalid URL, skip filtering
      }
    }

    return privateTelemetry(event);
  },

  // Ignore common errors that don't need tracking
  ignoreErrors: [
    // Browser extensions
    'top.GLOBALS',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'atomicFindClose',
    // Network errors
    'NetworkError',
    'Network request failed',
    // User-triggered errors
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
  ],
});
